module.exports = __webpack_public_path__ + "img/icon-profile.31d06562.svg";